import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {finalize, first, tap} from "rxjs/operators";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-single-file-upload',
  templateUrl: './single-file-upload.component.html',
  styleUrls: ['./single-file-upload.component.css']
})
export class SingleFileUploadComponent implements OnInit {

  private _imageUrl: Subject<string> = new BehaviorSubject(null);
  public imageUrl$: Observable<string> = this._imageUrl.asObservable();

  @Input() path: string = null;
  @Output() pathChange = new EventEmitter();

  @Input() downloadURL: string = null;
  @Output() downloadURLChange = new EventEmitter();

  uploadPercent$: Observable<number> = new Observable<number>(observable => observable.next(0));

  constructor(private storage: AngularFireStorage) {
  }

  ngOnInit() {
    if (this.path != null) {
      if (this.downloadURL == null) {
        this.storage.ref(this.path).getDownloadURL().pipe(
          first(),
          tap(v => {
            this._imageUrl.next(v);
          })
        ).subscribe();
      } else {
        this._imageUrl.next(this.downloadURL);
      }
    }
  }

  onFilesAdded(files: File[]) {
    const newFilePath: string = `recepten/${uuidv4()}`;
    const ref = this.storage.ref(newFilePath);
    const task = ref.put(files[0]);

    this.uploadPercent$ = task.percentageChanges();
    this.uploadPercent$.subscribe(console.log);
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.setPath(newFilePath);
        })
      )
      .subscribe();
  }

  onFileRemoved() {
    this.setPath(null);
  }

  setPath(path: string) {
    if (path == null || path.length == 0) {
      this.pathChange.emit(null);
      this.downloadURLChange.emit(null);
      this._imageUrl.next(null);
    } else {
      this.pathChange.emit(path);
      this.storage.ref(path).getDownloadURL().pipe(
        first(),
        tap(v => {
          this.downloadURLChange.emit(v);
          this._imageUrl.next(v);
        })
      ).subscribe();
    }
  }

}
